import { IconWrapper } from '@flexo/general';
import {
  ALERT,
  alertCallbackStore,
  METADATA,
  RIGHT_DRAWER,
} from '@flexo/reducers';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import Button from '../../button/button';
import styles from './../alert.module.scss';

export default function AlertRemoveUser() {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const content = t('alerts.remove_user', { returnObjects: true }) as any;

  async function onConfirm() {
    const data = alertCallbackStore.getData();

    if (data.userId && data.organizationId) {
      try {
        const result = await dispatch(
          METADATA.DisableUserAsync({
            dispatch,
            organizationId: data.organizationId,
            userId: data.userId,
          }) as any
        );

        alertCallbackStore.clearAll();

        // Check if the operation was successful
        if (result?.payload?.success) {
          // Close drawer on success
          dispatch(RIGHT_DRAWER.ResetDrawer({} as any));
          // Alert will be reset by the success banner timeout or user can dismiss it
        }
        // If failed, DisableUserAsync already shows BANNER_UNEXPECTED_ERROR
        // Don't reset the alert - let the error banner be visible
      } catch (error) {
        console.error('AlertRemoveUser: error disabling user:', error);
        alertCallbackStore.clearAll();
        // Don't reset alert - let the error banner show
      }
    } else {
      // No data - just close
      alertCallbackStore.clearAll();
      dispatch(ALERT.ResetAlert({} as any));
    }
  }

  function onCancel() {
    alertCallbackStore.clearAll();
    dispatch(ALERT.ResetAlert({} as any));
  }

  return (
    <div>
      <div
        id="alert-remove-user"
        className={`${styles.Alert} ${styles.Alert__Confirm__Credentials__Changes}`}
      >
        <div className={styles.Alert__Title__Negative}>
          <div>
            <IconWrapper iconName="alert" />
            {content.title}
          </div>
          <div className={styles.Alert__Title__Close}></div>
        </div>

        <div className={styles.Alert__Content}>{content.description}</div>

        <div className={`${styles.Alert__Footer__Actions} mt-2`}>
          <Button
            variant="secondary"
            color="grey"
            className={`${styles.Alert__Footer__Actions__Button} ${styles.Alert__Footer__Actions__Button__Cancel}`}
            label={content.cancel}
            onClick={onCancel}
          />
          <Button
            className={`${styles.Alert__Footer__Actions__Button} ${styles.Alert__Footer__Actions__Button__Confirm}`}
            variant="primary"
            color="negative"
            label={content.remove}
            onClick={onConfirm}
          />
        </div>
      </div>
    </div>
  );
}
